import { createContext } from 'react';

import { SemanticHeadingBaseLevel } from './SemanticHeading.types';

const SemanticHeadingBaseLevelContext = createContext<SemanticHeadingBaseLevel>(0);

export default SemanticHeadingBaseLevelContext;
